import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";

export default function AdminIAAlertsPage() {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAlerts() {
      const { data, error } = await supabase
        .from("ia_alerts")
        .select("id, artist, medium, type, message, created_at")
        .order("created_at", { ascending: false });

      if (!error) setAlerts(data);
      setLoading(false);
    }
    fetchAlerts();
  }, []);

  if (loading) return <p>Chargement des alertes IA...</p>;

  return (
    <div className="max-w-5xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">🧠 Alertes IA : Vente recommandée</h1>
      <div className="space-y-4">
        {alerts.map((alert) => (
          <div key={alert.id} className="border rounded p-4 bg-white shadow">
            <p className="text-sm text-gray-500">{new Date(alert.created_at).toLocaleString()}</p>
            <p className="font-semibold text-lg">{alert.artist} ({alert.medium})</p>
            <p className="text-sm text-blue-800 mt-1">📢 {alert.message}</p>
            <span className="text-xs bg-gray-100 px-2 py-1 rounded mt-2 inline-block">
              Type : {alert.type}
            </span>
          </div>
        ))}
        {alerts.length === 0 && <p className="text-sm text-gray-500">Aucune alerte récente.</p>}
      </div>
    </div>
  );
}
